// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3a48u","footer":"ModalFilter_footer__1SgRq"};